import { Button, Box, Typography } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone'
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled'
import styles from './PhoneCallButtons.module.scss'

interface PhoneCallButtonsProps {
  patientPhoneNumber?: string | null
  pharmacyPhoneNumber?: string | null
}

const PhoneCallButtons = ({
  patientPhoneNumber,
  pharmacyPhoneNumber,
}: PhoneCallButtonsProps) => {
  return (
    <Box className={styles.phoneCallsContainer}>
      <Box className={styles.contactContainer}>
        <Typography variant="h3">Contact</Typography>
        <Typography variant="body2" color="text.secondary">
          Call patient or pharmacy for follow-up
        </Typography>
      </Box>

      <Box className={styles.phoneCallButtonsContainer}>
        <Box className={styles.buttonWrapper}>
          <Button
            variant="contained"
            fullWidth
            startIcon={
              patientPhoneNumber ? <PhoneIcon /> : <PhoneDisabledIcon />
            }
            href={patientPhoneNumber ? `tel:${patientPhoneNumber}` : undefined}
            className={styles.button}
            disabled={!patientPhoneNumber}
          >
            {patientPhoneNumber ? (
              <>
                Call Patient
                {patientPhoneNumber && (
                  <Typography variant="body2" className={styles.phoneNumber}>
                    {patientPhoneNumber}
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="caption" className={styles.helperText}>
                No patient phone number available
              </Typography>
            )}
          </Button>
        </Box>
        <Box className={styles.buttonWrapper}>
          <Button
            variant="contained"
            fullWidth
            startIcon={
              pharmacyPhoneNumber ? <PhoneIcon /> : <PhoneDisabledIcon />
            }
            href={
              pharmacyPhoneNumber ? `tel:${pharmacyPhoneNumber}` : undefined
            }
            className={styles.button}
            disabled={!pharmacyPhoneNumber}
          >
            {pharmacyPhoneNumber ? (
              <>
                Call Pharmacy
                {pharmacyPhoneNumber && (
                  <Typography variant="body2" className={styles.phoneNumber}>
                    {pharmacyPhoneNumber}
                  </Typography>
                )}
              </>
            ) : (
              <Typography variant="caption" className={styles.helperText}>
                No pharmacy phone number available
              </Typography>
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default PhoneCallButtons
